import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import axios from "axios";
import MicroModal from "micromodal";

import Button from "../Button";

import { ReactComponent as IconCloseCircle } from "../../../build/images/platformnps/closecircle.svg";
import { ReactComponent as IconSuccess } from "../../../build/images/platformnps/sucess.svg";
import { ReactComponent as IconBox } from "../../../build/images/platformnps/box.svg";
import { ReactComponent as IconBreak } from "../../../build/images/platformnps/break.svg";
import { ReactComponent as IconNoAnswer } from "../../../build/images/platformnps/callend.svg";
import { ReactComponent as IconBlock } from "../../../build/images/platformnps/block.svg";

import { connection_platform } from "../../../services/api";
import {
  addMessage,
  getQuickAnswerCall,
  getStatusReportCall,
  insertReportCall,
  removeAnswerHidden,
  startCallHidden,
} from "../../../actions";
import {
  InviteMessages,
  SendByeAnswerHidden,
} from "../../../actions/websocket";
import generator_callid from "../../../actions/makeidCall";

const { meses } = require("../../../services/data");

// let url_connection = `${connection_platform.type_connect}:${localStorage.getItem("pathname")}:${localStorage.getItem("port")}`
// let url_connection = `https://cloud.ingweb.com.br:8080`
let url_connection = `${connection_platform.type_connect}://${connection_platform.ip_intern}:${connection_platform.port_backend_intern}`;

const ReportCallCenterModal = ({ modalTitle, data }) => {
  const [report, setReport] = useState(0);
  const [statusSelected, setStatusSelected] = useState(0);
  const [channel, setChannel] = useState(12);
  const [statusReport, setStatusReport] = useState([]);
  const dispatch = useDispatch();
  const [quickAnswers, setQuickAnswers] = useState([]);
  const answerReducer = useSelector((state) => state.atendimento);
  const userReducer = useSelector((state) => state.informationusers);
  const [textObservation, setTextObservation] = useState("");
  const answerHiddenReducer = useSelector((state) => state.answerhidden);

  const isFromCallCenter = !!data && data.isFromCallCenter;

  useEffect(() => {
    if (answerHiddenReducer.length !== 0) {
      sendMsgReport(answerHiddenReducer);
      dispatch(removeAnswerHidden());
      setTimeout(() => {
        SendByeAnswerHidden(answerHiddenReducer, userReducer);
      }, 1500);
    }
  }, [answerHiddenReducer]);

  useEffect(() => {
    getStatusReport();
    getQuickAnswer();
  }, []);

  const getStatusReport = async () => {
    if (isFromCallCenter) {
      const response = await getStatusReportCall();
      const hasResponse = !!response && response.status === 200;
      if (hasResponse) {
        const data = response.data;
        const hasData = !!data && data.length > 0;
        if (hasData) {
          setStatusReport(response.data);
        }
      }
    }
  };

  const getQuickAnswer = async () => {
    if (isFromCallCenter) {
      const response = await getQuickAnswerCall();
      if (response.data !== "") {
        setQuickAnswers(response.data);
        if (response.data !== 0) {
          setReport(response.data[0].qck_asw_id);
          setTextObservation(response.data[0].qck_asw_answer);
        }
      }
    }
  };

  const handleReport = (idReport, textReport) => {
    setReport(idReport);
    setTextObservation(textReport);
  };

  const saveReportEvaluation = async () => {
    if (statusSelected !== 0) {
      MicroModal.close("modal-component-report-modal");
      if (isFromCallCenter) {
        await insertReportCall(data, statusSelected, textObservation);
      }

      if (channel === 5 && parseInt(answerReducer.idmidia) === 5) {
        sendMsgReport(answerReducer);
      } else if (channel === 5 && parseInt(answerReducer.idmidia) !== 5) {
        dispatch(startCallHidden(5, answerReducer.telefone, undefined));
      } else if (channel === 12) {
        dispatch(startCallHidden(12, answerReducer.telefone, undefined));
      }
    }
  };

  const sendMsgReport = (answerSendMessage) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    let makeid = generator_callid(32);
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];

    let msgweb = textObservation;
    let msgsocket = textObservation;

    msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
    msgweb = msgweb.replace(/"/gm, '\\"');

    msgsocket = msgsocket.trim();
    msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
    msgsocket = msgsocket.replace(/"/gm, '\\"');

    if (msgweb != "") {
      dispatch(
        addMessage(
          makeid,
          msgweb,
          "Me",
          time,
          answerSendMessage.idatendimento,
          "0",
          "entregue",
          false,
          dia,
          "",
          "",
          "",
          "0",
          null
        )
      );
      InviteMessages(
        userReducer,
        answerSendMessage,
        msgsocket,
        "Me",
        makeid,
        false,
        [],
        0,
        null,
        null,
        []
      );
    }
  };

  const closeModal = () => {
    MicroModal.close("modal-component-report-modal");
  };

  return (
    <div
      className="modal micromodal-slide"
      id="modal-component-report-modal"
      aria-hidden="true"
    >
      <div className={`modal__overlay`} aria-modal="true" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          style={{ padding: "24px", borderRadius: "8px" }}
        >
          <div className="modal-component__general">
            <div className="modal-component__general__header">
              <span>{modalTitle}</span>
              <div className="modal_close" onClick={() => closeModal()}>
                <IconCloseCircle />
              </div>
            </div>
            <div className="modal-component__general__body">
              <div className="modal-component__general__body-evaluation">
                <p>Avalie como foi o contato com o cliente:</p>
                {statusReport.map((status) => (
                  <div
                    key={status.id}
                    className={
                      statusSelected === status.id
                        ? "modal-component__general__body-evaluation__box-green"
                        : statusSelected === 0
                        ? "modal-component__general__body-evaluation__box"
                        : "modal-component__general__body-evaluation__box-red"
                    }
                    onClick={() => setStatusSelected(status.id)}
                  >
                    {status.id === 1 && <IconSuccess />}
                    {status.id === 2 && <IconBox />}
                    {status.id === 3 && <IconBreak />}
                    {status.id === 4 && <IconNoAnswer />}
                    {status.id === 5 && <IconBlock />}
                    <span>{status.description}</span>
                  </div>
                ))}
              </div>
              <div className="modal-component__general__body-report">
                <span>Reportar ao cliente:</span>
                <div className="modal-component__general__body-forms">
                  {quickAnswers.map((quick, index) => (
                    <div
                      className={
                        quick.qck_asw_id === report
                          ? "modal-component__general__body-forms_item-marked"
                          : "modal-component__general__body-forms_item"
                      }
                    >
                      <label>
                        <input
                          type="radio"
                          name="item-report"
                          defaultChecked={index === 0 ? true : false}
                          onClick={() =>
                            handleReport(quick.qck_asw_id, quick.qck_asw_answer)
                          }
                        />
                        <span>{quick.qck_asw_keyword}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="modal-component__general__body-report">
                <span>Selecione o canal:</span>
                <div className="modal-component__general__body-forms">
                  <div
                    className={
                      channel === 12
                        ? "modal-component__general__body-forms_item-marked"
                        : "modal-component__general__body-forms_item"
                    }
                  >
                    <label>
                      <input
                        type="radio"
                        name="item-channel"
                        defaultChecked={channel === 12 ? true : false}
                        onClick={() => setChannel(12)}
                      />
                      <span>SMS</span>
                    </label>
                  </div>
                  <div
                    className={
                      channel === 5
                        ? "modal-component__general__body-forms_item"
                        : "modal-component__general__body-forms_item-marked"
                    }
                  >
                    <label>
                      <input
                        type="radio"
                        name="item-channel"
                        onClick={() => setChannel(5)}
                      />
                      <span>WhatsApp</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-component__general__body-msg__content">
              <div className="modal-component__general__body-msg__content-block">
                <span>
                  Mensagem ({channel === 5 ? "4096" : "140"} caracteres)
                </span>
                <textarea
                  defaultValue={textObservation}
                  onChange={(event) => setTextObservation(event.target.value)}
                />
              </div>
            </div>
            <div className="modal-component__general__body-actions">
              <Button
                label="Cancelar"
                theme="danger"
                action={() => closeModal()}
              />
              <Button
                label="Salvar"
                theme="primary"
                action={() => saveReportEvaluation()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCallCenterModal;
